<template>
  <b-modal
    ref="confirmModal"
    class="modal"
    :no-close-on-backdrop="true"
    :no-close-on-esc="true"
  >
    <template
      slot="modal-header"
    >
      <h5>{{ title }}</h5>
      <button
        class="btn btn--close"
        type="button"
        @click="doCancel()"
      >
        <font-awesome-icon
          :icon="['fal', 'times']"
          class="icon alt"
        />
      </button>
    </template>

    <slot>
      <p>{{ body }}</p>
    </slot>

    <template
      slot="modal-footer"
    >
      <button
        :disabled="saving"
        class="btn"
        type="button"
        @click="doCancel()"
      >
        Cancel
      </button>
      <button
        :disabled="saving"
        class="btn btn--primary"
        type="button"
        @click="doConfirm()"
      >
        <font-awesome-icon
          v-if="saving"
          :spin="true"
          :icon="['fas', 'spinner']"
          class="icon alt"
        />
        <span v-else>Yes</span>
      </button>
    </template>
  </b-modal>
</template>

<script>
/* eslint-disable vue/require-default-prop */
export default {
  name: 'ConfirmDialogModal',
  components: {

  },
  props: {
    title: {
      type: String,
    },
    body: {
      type: String,
    },
    onConfirm: {
      // this should return a boolean for "closeModal"
      type: Function,
    },
  },
  data() {
    return {
      saving: false,
    };
  },
  computed: {

  },
  watch: {

  },
  mounted() {

  },
  methods: {
    doConfirm() {
      this.saving = true;

      let closeModal = true;
      if (this.onConfirm) {
        closeModal = this.onConfirm(() => {
          // on done saving
          this.saving = false;
        });
      }
      if (closeModal) {
        this.hide();
      }
    },
    doCancel() {
      this.hide();
    },
    show() {
      this.$refs.confirmModal.show();
      this.saving = false;
    },
    hide() {
      this.$refs.confirmModal.hide();
    },
  },
};
</script>

<style>

</style>
